import React, { useContext, useEffect } from 'react';
import { ReferrerContext } from 'components/layout/ReferrerContext';
import { NavigationUtils } from 'lib/navigationUtilities';
import Button from 'components/element/Button';

const HeaderSignedOut = () => {
  const { referrer, updateReferrer } = useContext(ReferrerContext);
  const { locationPathName, navigateToLocation } = NavigationUtils();

  const isLoginPage = locationPathName === '/login';
  const isRegisterPage = locationPathName === '/register';

  useEffect(() => {
    if (!isLoginPage && !isRegisterPage) {
      updateReferrer(locationPathName);
    }
  }, [locationPathName, updateReferrer, isLoginPage, isRegisterPage]);

  return (
    <div className="flex gap-4">
      {!isLoginPage && (
        <Button onClick={() => navigateToLocation('/login')} className="text-white bg-blue-mid hover:bg-blue-more sm:w-22">
          <div className="block sm:hidden">
            <i className="fas fa-sign-in-alt"></i>
          </div>
          <div className="hidden sm:block">
            Login
          </div>
        </Button>
      )}

      {!isRegisterPage && (
        <Button onClick={() => navigateToLocation('/register')} className="text-white bg-blue-mid hover:bg-blue-more sm:w-22">
          <div className="block sm:hidden">
            <i className="fas fa-user-plus"></i>
          </div>
          <div className="hidden sm:block">
            Register
          </div>
        </Button>
      )}

      {(isLoginPage || isRegisterPage) && (
        <Button onClick={() => navigateToLocation(referrer || '/')} className="text-white bg-blue-mid hover:bg-blue-more sm:w-22">
          <div className="block sm:hidden">
            <i className="fas fa-home"></i>
          </div>
          <div className="hidden sm:block">
            Home
          </div>
        </Button>
      )}
    </div>
  );
}

export default HeaderSignedOut;
